// Workspace Products Data
export const workspaceProducts = {
  'office-space': {
    id: 'office-space',
    title: 'Office Space',
    description: 'Professional office spaces designed for productivity and growth',
    icon: 'Building2',
    products: [
      {
        id: 'private-cabin',
        name: 'Private Cabin',
        description: 'Premium workspace with complete privacy and professional ambience for focused work and confidential discussions.',
        image: './images/galery-images/IMG_6808.JPG',
        features: ['Premium Workspace', 'Ergonomic Setup', 'Meeting Access', 'Confidential Focus', 'Professional Ambience', 'Elevated Experience', 'Seamless Connectivity', 'Business Privacy'],
        pricing: '₹8,999/seat',
        availability: '10 available',
        ctaText: 'Reserve Now',
        ctaSecondary: 'Learn more'
      },
      {
        id: 'day-offices',
        name: 'Day Offices',
        description: 'Flexible access premium setup with no commitment required. Perfect for professionals who need workspace on-demand.',
        image: 'https://images.squarespace-cdn.com/content/v1/5877fcf8ebbd1a0e70bf993e/1625285912027-7HK6VJ5B56JGIJSHZPVK/day+offices_3.jpg?format=1000w',
        features: ['Flexible Access', 'Premium Setup', 'Ergonomic Comfort', 'High-Speed Connectivity', 'Meeting Access', 'Professional Ambience', 'No Commitment', 'Productive Environment'],
        pricing: '₹500/day',
        availability: '5 available',
        ctaText: 'Reserve Now',
        ctaSecondary: 'Learn more'
      }
    ]
  },
  
  'coworking': {
    id: 'coworking',
    title: 'Coworking',
    description: 'Flexible coworking spaces for individuals and teams',
    icon: 'Users',
    products: [
      {
        id: 'single-seat-cabin',
        name: 'Single Seat Private Cabin',
        description: 'Dedicated workspace with complete privacy and ergonomic comfort. Perfect for focused work and confidential discussions.',
        image: './images/galery-images/IMG_6843.JPG',
        features: ['Dedicated Workspace', 'Ergonomic Comfort', 'Complete Privacy', 'Professional Setting', 'Meeting Access', 'Quiet Environment', 'Seamless Productivity', 'Premium Interiors', 'Confidential Discussions', 'Focused Ambience', 'High-Speed Internet'],
        pricing: '₹8,999/month',
        availability: '8 available',
        ctaText: 'Reserve Now',
        ctaSecondary: 'Learn more'
      },
      {
        id: '2-seat-cabin',
        name: '2 Seat Private Cabin',
        description: 'Ideal workspace for partners with premium interiors and seamless collaboration setup for enhanced productivity.',
        image: './images/galery-images/IMG_6813.JPG',
        features: ['Ideal for Partners', 'Premium Workspace', 'Elegant Interiors', 'Confidential Meetings', 'Seamless Collaboration', 'Professional Ambience', 'Enhanced Productivity', 'Business Growth', 'Comfort Redefined', 'High-Speed Internet'],
        pricing: '₹16,999/month',
        availability: '4 available',
        ctaText: 'Reserve Now',
        ctaSecondary: 'Learn more'
      },
      {
        id: '6-seat-cabin',
        name: '6 Seat Private Cabin',
        description: 'Spacious team cabin with elegant interiors and collaborative ambience. Perfect for team synergy and business growth.',
        image: './images/galery-images/IMG_6810.JPG',
        features: ['Spacious Team Cabin', 'Elegant Interiors', 'Ergonomic Setup', 'Complete Privacy', 'Collaborative Ambience', 'Professional Environment', 'Focus-Driven Space', 'Productive Atmosphere', 'Team Synergy', 'Business Growth'],
        pricing: '₹41,999/month',
        availability: '2 available',
        ctaText: 'Reserve Now',
        ctaSecondary: 'Learn more'
      }
    ]
  },

  'virtual-office': {
    id: 'virtual-office',
    title: 'Virtual Office',
    description: 'Professional business presence without physical office space',
    icon: 'Globe',
    products: [
      {
        id: 'company-registration',
        name: 'New Company Registration Plan',
        description: 'Register your company at premium addresses in any city in India without taking a physical office space.',
        image: 'https://filingpoint.com/images/company-registration-one-day-filingpoint-consultants-india-chennai-tn-online.jpg',
        features: ['Company Registration Address', 'GST Registration', 'Mail & Courier Handling', 'Address on Business Cards, Letter Heads'],
        pricing: 'From ₹666/Month',
        availability: 'Always available',
        ctaText: 'Get started',
        ctaSecondary: 'Learn more'
      },
      {
        id: 'gst-registration',
        name: 'New GST Registration',
        description: 'Expand your existing business operations into new states with ease. Our service helps you register for GST Additional Place of Business (APOB) quickly and compliantly.',
        image: './images/GST TAX Image.png',
        features: ['GST Registration for Additional Place of Business (APOB)', 'Mail & Courier Handling', 'Address on Business Cards, Letter Heads'],
        pricing: 'From ₹499/Month',
        availability: 'Always available',
        ctaText: 'Get started',
        ctaSecondary: 'Learn more'
      },
      {
        id: 'business-address',
        name: 'Business Address Plan',
        description: 'Get a professional business address for your company at prime locations across major cities in India without the cost of renting a physical office.',
        image: './images/bap.jpg',
        features: ['Mail & Courier Handling Services', 'Business Address for Official Use', 'Prime Location Advantage', 'Brand Credibility Enhancement'],
        pricing: 'From ₹416/Month',
        availability: 'Always available',
        ctaText: 'Get started',
        ctaSecondary: 'Learn more'
      }
    ]
  },

  'meeting-rooms': {
    id: 'meeting-rooms',
    title: 'Meeting Rooms',
    description: 'Professional meeting spaces for all your business needs',
    icon: 'Users',
    products: [
      {
        id: 'meeting-room',
        name: 'Meeting Room',
        description: 'Modern meeting spaces with smart presentation setup and collaborative ambience for productive discussions. Available in 4, 6, 8 seater options.',
        image: './images/galery-images/IMG_E6855.JPG',
        features: ['Modern Meeting Spaces', 'Elegant Interiors', 'Smart Presentation Setup', 'Collaborative Ambience', 'Confidential Environment', 'Professional Impression', 'Seamless Connectivity', 'Productive Discussions', 'Client-Ready Setup', 'Inspiring Atmosphere'],
        pricing: 'Starts from ₹799/hour',
        availability: '3 rooms available',
        ctaText: 'Book now',
        ctaSecondary: 'View details'
      },
      {
        id: 'interview-room',
        name: 'Interview Room',
        description: 'Professional ambience with confidential environment and comfortable seating. Ideal for HR and client meetings.',
        image: 'https://c615.co/wp-content/uploads/2023/05/center-615-c615-why-how-and-where-to-rent-a-meeting-room-for-a-video-interview-nashville-tn-1024x512.jpg',
        features: ['Professional Ambience', 'Confidential Environment', 'Comfortable Seating', 'Noise-Free Space', 'Candidate-Friendly Setup', 'Smart Presentation Ready', 'Impressive First Impression', 'Flexible Booking Options', 'Hassle-Free Access', 'Ideal for HR & Client Meetings'],
        pricing: '₹799/hour',
        availability: '2 rooms available',
        ctaText: 'Book now',
        ctaSecondary: 'View details'
      },
      {
        id: 'training-room',
        name: 'Training Room',
        description: 'Spacious setup with modern presentation tools and collaborative environment. Perfect for workshops and team development.',
        image: 'https://www.2010officefurniture.com/wp-content/uploads/2023/09/48-enwork-ritz-flip-tables.jpg',
        features: ['Spacious Setup', 'Collaborative Environment', 'Modern Presentation Tools', 'Comfortable Seating', 'Distraction-Free Space', 'Ideal for Workshops & Seminars', 'Professional Ambience', 'Flexible Layout Options', 'Seamless Connectivity', 'Perfect for Team Development'],
        pricing: '₹799/hour',
        availability: '1 room available',
        ctaText: 'Book now',
        ctaSecondary: 'View details'
      }
    ]
  },

  'business-addresses': {
    id: 'business-addresses',
    title: 'Business Addresses',
    description: 'Prestigious business addresses for your company registration',
    icon: 'MapPin',
    products: [
      {
        id: 'registered-address',
        name: 'Registered Office Address',
        description: 'Legal business address for company registration and compliance requirements.',
        image: 'https://www.shutterstock.com/image-photo/tall-skyscrapers-buildings-looking-perspective-600nw-2446848289.jpg',
        features: ['Legal compliance', 'Mail forwarding', 'Government liaison'],
        pricing: 'Starting from ₹1,500/month',
        availability: 'Always available',
        ctaText: 'Get address',
        ctaSecondary: 'Learn more'
      },
      {
        id: 'mailing-address',
        name: 'Mailing Address',
        description: 'Professional mailing address with mail handling and forwarding services.',
        image: 'https://static.vecteezy.com/system/resources/thumbnails/002/553/692/small/fast-mail-envelope-address-postal-delivery-line-style-icon-free-vector.jpg ',
        features: ['Mail handling', 'Package receipt', 'Mail forwarding'],
        pricing: 'Starting from ₹1,000/month',
        availability: 'Always available',
        ctaText: 'Get address',
        ctaSecondary: 'Learn more'
      }
    ]
  },

  'private-offices': {
    id: 'private-offices',
    title: 'Private Offices',
    description: 'Fully private office spaces for focused work and confidential meetings',
    icon: 'Lock',
    products: [
      {
        id: 'executive-office',
        name: 'Executive Office',
        description: 'Premium private office with executive desk, meeting area, and personal storage.',
        image: './images/galery-images/IMG_6847.JPG',
        features: ['Private entrance', 'Executive furniture', 'Meeting area'],
        pricing: 'Starting from ₹25,000/month',
        availability: '2 available',
        ctaText: 'Schedule tour',
        ctaSecondary: 'Learn more'
      },
      {
        id: 'custom-office',
        name: 'Custom Private Office',
        description: 'When off-the-shelf simply isn\'t enough. Customize all aspects of your space, including furniture and branding.',
        image: './images/galery-images/IMG_6847.JPG',
        features: ['By month or year + customized', 'Teams of any size', 'Full branding'],
        pricing: 'Custom pricing',
        availability: '1 available',
        ctaText: 'Reserve Now',
        ctaSecondary: 'Learn more'
      }
    ]
  },

  'day-offices': {
    id: 'day-offices',
    title: 'Day Offices',
    description: 'On-demand office space perfect for daily productivity',
    icon: 'Clock',
    products: [
      {
        id: 'daily-office',
        name: 'Daily Office Space',
        description: 'A professional on-demand office space. Perfect when you need to get your head down and do your best work.',
        image: './images/galery-images/IMG_6848.JPG',
        features: ['By the hour or day', 'Teams of any size', 'All amenities included'],
        pricing: 'Starting from ₹200/hour',
        availability: '5 offices available',
        ctaText: 'Reserve Now',
        ctaSecondary: 'Learn more'
      },
      {
        id: 'focus-room',
        name: 'Focus Room',
        description: 'Quiet, distraction-free space for individual work and important calls.',
        image: './images/galery-images/IMG_6849.JPG',
        features: ['Soundproof', 'Individual use', 'By hour or day'],
        pricing: 'Starting from ₹150/hour',
        availability: '8 rooms available',
        ctaText: 'Reserve Now',
        ctaSecondary: 'Learn more'
      }
    ]
  }
};

// Helper function to get all products
export const getAllProducts = () => {
  const allProducts = [];
  Object.values(workspaceProducts).forEach(category => {
    category.products.forEach(product => {
      allProducts.push({
        ...product,
        category: category.id,
        categoryTitle: category.title
      });
    });
  });
  return allProducts;
};

// Helper function to get products by category
export const getProductsByCategory = (categoryId) => {
  return workspaceProducts[categoryId]?.products || [];
};

// Helper function to get category info
export const getCategoryInfo = (categoryId) => {
  return workspaceProducts[categoryId] || null;
};

// Navigation items for header (existing structure maintained)
export const navigationItems = [
  {
    id: 'office-space',
    label: 'Office Space',
    icon: 'Building2',
    route: '/office-space',
    items: [
      { name: 'Private Cabin', desc: 'Premium private workspace', units: '10 available', route: '/office-space#private-cabin' },
      { name: 'Day Offices', desc: 'Flexible daily workspace', units: '5 available', route: '/office-space#day-offices' }
    ]
  },
  {
    id: 'coworking',
    label: 'Coworking',
    icon: 'Users',
    route: '/coworking',
    items: [
      { name: 'Single Seat Cabin', desc: 'Individual private cabin', units: '8 available', route: '/coworking#single-seat-cabin' },
      { name: '2 Seat Cabin', desc: 'Perfect for partnerships', units: '4 available', route: '/coworking#2-seat-cabin' },
      { name: '6 Seat Cabin', desc: 'Team collaboration space', units: '2 available', route: '/coworking#6-seat-cabin' }
    ]
  },
  {
    id: 'virtual-office',
    label: 'Virtual Office',
    icon: 'Globe',
    route: '/virtual-office',
    items: [
      { name: 'Company Registration', desc: 'Register at premium addresses', units: 'Always available', route: '/virtual-office#company-registration' },
      { name: 'GST Registration', desc: 'APOB registration support', units: 'Always available', route: '/virtual-office#gst-registration' },
      { name: 'Business Address', desc: 'Professional business address', units: 'Always available', route: '/virtual-office#business-address' }
    ]
  },
  {
    id: 'meeting-rooms',
    label: 'Meeting Rooms',
    icon: 'Users',
    route: '/meeting-rooms',
    items: [
      { name: 'Meeting Room', desc: '4, 6, 8 seater options', units: '3 rooms available', route: '/meeting-rooms#meeting-room' },
      { name: 'Interview Room', desc: 'HR and client meetings', units: '2 rooms available', route: '/meeting-rooms#interview-room' },
      { name: 'Training Room', desc: 'Workshops and seminars', units: '1 room available', route: '/meeting-rooms#training-room' }
    ]
  },
  {
    id: 'business-addresses',
    label: 'Business Addresses',
    icon: 'MapPin',
    route: '/business-addresses',
    items: [
      { name: 'Registered Address', desc: 'Legal business address', units: 'Always available', route: '/business-addresses#registered-address' },
      { name: 'Mailing Address', desc: 'Professional mailing service', units: 'Always available', route: '/business-addresses#mailing-address' }
    ]
  },
  {
    id: 'private-offices',
    label: 'Private Offices',
    icon: 'Lock',
    route: '/private-offices',
    items: [
      { name: 'Executive Office', desc: 'Premium private workspace', units: '2 available', route: '/private-offices#executive-office' },
      { name: 'Custom Office', desc: 'Fully customized workspace', units: '1 available', route: '/private-offices#custom-office' }
    ]
  },
  {
    id: 'day-offices',
    label: 'Day Offices',
    icon: 'Clock',
    route: '/day-offices',
    items: [
      { name: 'Daily Office', desc: 'On-demand office space', units: '5 offices available', route: '/day-offices#daily-office' },
      { name: 'Focus Room', desc: 'Quiet individual workspace', units: '8 rooms available', route: '/day-offices#focus-room' }
    ]
  }
];
